import Footer, { FooterProps } from '@common/footer/footer';
import { Version } from '@common/footer/version';
import Header, { HeaderMode, HeaderProps } from '@common/header/header';
import { useQuery } from '@hooks/use-query';
import { reauthUser } from '@redux/auth/auth-dispatcher';
import { Storage } from '@services/storage/storage';
import React, { useEffect } from 'react';
import { PrivacyPolicy } from '../common/privacy-policy/privacy-policy';
import CustomerChat from '../components/facebook/customer-chat';

export interface LayoutProps {
    headerMode?: HeaderMode;
    wrapperClass?: string;
    hideHeader?: boolean;
    hideFooter?: boolean;
    baseHeaderPaddingClass?: string;
    headerOptions?: HeaderProps;
    footerOptions?: FooterProps;
    hideCustomerChat?: boolean;
}

/**
 * The main application layout
 *
 * @param ComposedComponent
 * @param overrides
 */
const Layout = (ComposedComponent, overrides: LayoutProps = {}) => props => {
    const { refer } = useQuery();

    useEffect(() => {
        if (location.hash) {
            location = location;
        }
    }, []);

    // invoke reauthentication
    useEffect(() => {
        (async () => {
            try {
                await reauthUser();

                if (refer) {
                    Storage.setItem('referralId', refer);
                }
            } catch (error) {
                // do nothing
            }
        })();
    }, []);

    return (
        <React.Fragment>
            {overrides.hideHeader ? '' : <Header {...overrides.headerOptions} mode={overrides.headerMode} />}

            <main
                className={
                    'z-0 -flex justify-center flex-col items-center w-screen relative ' +
                    (overrides.baseHeaderPaddingClass ? overrides.baseHeaderPaddingClass : 'base-header-padding-top') +
                    ' ' +
                    (overrides.wrapperClass ? overrides.wrapperClass : '')
                }
            >
                <div className="w-full">
                    <ComposedComponent {...props} {...overrides} />
                </div>
            </main>

            {overrides.hideFooter ? '' : <Footer {...overrides.footerOptions} />}

            {overrides.hideCustomerChat ? '' : <CustomerChat />}
            <PrivacyPolicy />
            <Version />
        </React.Fragment>
    );
};

export default Layout;
